<template>
  <div class="menu-page">
    <v-card class="nd-border" flat>
      <v-card-title>
        Ofertas Guru
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" class="d-flex">
            <ib-text-field v-model="search" class="mb-6" append-icon="mdi-magnify" label="Busque por nome da oferta" clearable outlined single-line hide-details style="max-width: 500px;" />
            <v-spacer></v-spacer>
            <ib-btn color="primary" @click.native="openNew">
              <v-icon left>mdi-plus</v-icon>
              Nova oferta
            </ib-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-data-table :headers="headers" :items="filteredOffers" :loading="loading">
              <template #[`item.actions`]="{ item }">
                <v-menu>
                  <template #activator="{ on, attrs }">
                    <ib-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-horizontal</v-icon>
                    </ib-btn>
                  </template>

                  <v-card>
                    <v-list-item @click="openObject(item)">
                      <v-list-item-icon>
                        <v-icon>mdi-file-edit-outline</v-icon>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title>Editar</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-menu>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <ib-dialog v-model="dialog" scrollable max-width="600" persistent>
      <v-card>
        <ib-dialog-header title="Oferta" :close="() => { dialog = false }"></ib-dialog-header>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <ib-text-field v-model="object.name" class="pt-1" label="Nome da oferta" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12">
              <ib-text-field v-model="object.offer_id" class="pt-1" label="Offer id da Guru" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12">
              <ib-text-field v-model="object.max_channels" type="number" class="pt-1" label="Canais (não oficial)" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12">
              <ib-text-field v-model="object.max_official_channels" type="number" class="pt-1" label="Números (API oficial)" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12">
              <ib-text-field v-model="object.max_users" type="number" class="pt-1" label="Usuários" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12">
              <ib-text-field v-model="object.max_flows" type="number" class="pt-1" label="Fluxos" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12">
              <ib-text-field v-model="object.max_summaries" type="number" class="pt-1" label="Resumos com IA" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12">
              <ib-text-field v-model="object.max_follow_ups" type="number" class="pt-1" label="Follow-ups com IA" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12">
              <ib-text-field v-model="object.max_ai_replies" type="number" class="pt-1" label="Respostas com IA" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12">
              <v-switch v-model="object.campaigns_enabled" inset label="Campanhas habilitadas?" />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <ib-btn outlined color="gray200" @click.native="dialog = false">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>

          <v-spacer />

          <ib-btn color="primary" :loading="loading" @click.native="save">
            Salvar
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>
  </div>
</template>

<script>
import Api from "@/lib/Api";
import { emitToastr } from "@/lib/Utils";

export default {
  name: "OfertasView",

  data() {
    return {
      showVideo: false,
      objects: [],
      object: {},
      search: "",
      loading: true,
      dialog: false,
      headers: [
        { text: 'Nome', value: 'name', sortable: false },
        { text: 'Canais', value: 'max_channels', sortable: false },
        { text: 'Números (API Oficial)', value: 'max_official_channels', sortable: false },
        { text: 'Usuários', value: 'max_users', sortable: false },
        { text: 'Fluxos', value: 'max_flows', sortable: false },
        { text: 'Ações', value: 'actions', sortable: false },
      ]
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },

    filteredOffers() {
      if (!this.search) return this.objects;

      const normalize = str =>
        str.normalize("NFD") // decompõe acentos
          .replace(/[\u0300-\u036f]/g, "") // remove os acentos
          .toLowerCase(); // deixa tudo em minúsculo

      const searchTerm = normalize(this.search);

      return this.objects.filter(x => normalize(x.name).includes(searchTerm));
    }
  },

  async mounted() {
    await this.getObjects();
  },

  methods: {
    async getObjects() {
      this.loading = true;
      const resp = await Api.getGuruOffers();
      this.loading = false;

      if (!resp.error && resp.message) {
        this.objects = resp.message;
      }
    },

    openNew() {
      this.object = {};
      this.dialog = true;
    },

    openObject(item) {
      this.object = item;
      this.dialog = true;
    },

    async save() {
      if (!this.object.name) return emitToastr("error", "O nome é um campo necessário");

      this.loading = true;
      const resp = await Api.createOrUpdateGuruOffer(this.object);
      this.loading = false;

      if (!resp.error) {
        emitToastr("success", "Oferta salva com sucesso");
        this.getObjects();
        this.dialog = false;
      }
    }
  },
};
</script>

<style scoped></style>